import './App.css';
import Footer from './sections/Footer';
import Nav from './sections/Nav';
import Service from './sections/Service';
import Slider from './sections/Slider';
import Value from './sections/Value';
import Waitlist from './sections/Waitlist';
import Why from './sections/Why';



function App() {
  
  

  
  return (

    <div>
      <Nav/>
      <Slider/>
      <Why/>
      <Service/>
      <Waitlist/>
      <Value/>
      <Footer/>

    </div>
  );
}

export default App;
